import React from 'react';
import { Box, Modal } from '@mui/material';
import PreviewModalContext from '../context/PreviewModalContext';

import '../../styles/PreviewModal.scss';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: 24,
};

export default function PreviewModal({
  url,
  type,
  onClose,
  ...props
}) {
  return (
    <Modal
      {...props}
      open={!!url}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        {
          type === 'video' ? <video
            width="100%"
            src={url}
            controls
            autoPlay
            muted
            preload="metadata"
            playsInline
            /> : <img src={url} alt='' width='100%' height='100%' style={{ display: 'block' }} />
        }
      </Box>
  </Modal>
  );
}

const imageRegExp = /^.+\.(apng|avif|gif|jpg|jpeg|jpe|jif|jfif|png|bmp|svg|webp)$/i
const videoRegExp = /^.+\.(3gp|acc|flac|mpg|mpeg|mp3|mp4|m4a|m4v|m4p|oga|ogv|ogg|mov|wav|webm)$/i

export function PreviewTrigger ({
  children,
}) {
  const handler = (open) => (ref) => {
    if (!ref) return;
    const previewTags = ref.querySelectorAll('preview');
    previewTags.forEach(preview => {
      const url = preview.getAttribute('url');
      const type = preview.getAttribute('type');
      if (url) {
        if (type) {
          preview.onclick = () => open(url, type);
        } else if (imageRegExp.test(url)) {
          preview.onclick = () => open(url, 'image');
        } else if (videoRegExp.test(url)) {
          preview.onclick = () => open(url, 'video');
        }
      }
    });
    const aTags = ref.querySelectorAll('a');
    aTags.forEach(a => {
      const url = a.getAttribute('href');
      const type = a.getAttribute('type');
      if (url) {
        if (type && a.classList.contains('preview')) {
          a.onclick = (e) => {
            e.preventDefault();
            open(url, type);
          }
        } else if (imageRegExp.test(url)) {
          a.classList.add('preview');
          a.onclick = (e) => {
            e.preventDefault();
            open(url, 'image');
          }
        } else if (videoRegExp.test(url)) {
          a.classList.add('preview');
          a.onclick = (e) => {
            e.preventDefault();
            open(url, 'video');
          }
        }
      }
    })
  }
  return (
    <PreviewModalContext.Consumer>
      {({ open }) => children(handler(open), open)}
    </PreviewModalContext.Consumer>
  )
}
